import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import type { ComponentPropsWithoutRef } from 'react'

/* ------------------------------------------------------------------------------------------------- *
 * MedicationFileProcessed
 * ------------------------------------------------------------------------------------------------- */

type MedicationFileProcessedRootProps = ComponentPropsWithoutRef<'span'>

/**
 * Takes the place of the thumbnail of a file the care team processed: its
 * contents are gone, so there is nothing left to show.
 */
const MedicationFileProcessedRoot = ({ children, ...props }: MedicationFileProcessedRootProps) => (
  <StRoot {...props}>{children}</StRoot>
)

/* ------------------------------------------------------------------------------------------------- *
 * MedicationFileProcessed.Icon
 * ------------------------------------------------------------------------------------------------- */

type MedicationFileProcessedIconProps = ComponentPropsWithoutRef<typeof FontAwesomeIcon>

const MedicationFileProcessedIcon = (props: MedicationFileProcessedIconProps) => <StIcon aria-hidden {...props} />

/* ------------------------------------------------------------------------------------------------- *
 * Compound export
 * ------------------------------------------------------------------------------------------------- */

const MedicationFileProcessed = Object.assign(MedicationFileProcessedRoot, {
  Icon: MedicationFileProcessedIcon,
})

export { MedicationFileProcessed }

/* ------------------------------------------------------------------------------------------------- *
 * Styled
 * ------------------------------------------------------------------------------------------------- */

/** Sized like MedicationPhotoThumbnail, so the row keeps its shape. */
const StRoot = styled.span`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;

  ${({ theme }) => `
    border-radius: ${theme.UI.BorderRadius.Small};
    background: ${theme.Colors.Neutrals.Light};
  `}
`

const StIcon = styled(FontAwesomeIcon)`
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.Colors.Neutrals.Dark};
`
